import template from './upload.template.html';

export default {
  template,
  bindings: {
    url: '<',
    title: '<',
    allowMultiple: '<',
    allowedMimeTypes: '<',
    allowedExtensions: '<',
    cropImage: '<',
    cropType: '<',
    minimumWidth: '<',
    minimumHeight: '<',
    aspectRatio: '<',
    startUpload: '<',
    autoUpload: '<',
    allowUpload: '<',
    idContact: '<',
    idTicket: '<',
    importType: '<',
    onUploadFinished: '&'
  },
controller: class controller {
    constructor($timeout, uiService, Upload) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.croppedImageData = '';
      ctrl.uploadedFiles = [];
      ctrl.isUploading = false;
      ctrl.uploadProgress = 0;
      ctrl.cropImage = ctrl.cropImage ? ctrl.cropImage : false;
      ctrl.autoUpload = ctrl.autoUpload ? ctrl.autoUpload : false;
      ctrl.allowUpload = ctrl.allowUpload ? ctrl.allowUpload : false;

      /*
       * Event Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.upload = function () {
        var queuedFiles = [];
        if (ctrl.files) {
          if (ctrl.files instanceof Array) {
            queuedFiles = ctrl.files;
          } else {
            queuedFiles.push(
              ctrl.cropImage ? Upload.dataUrltoBlob(ctrl.croppedImageData) : ctrl.files
            );
          }
        }
        if (queuedFiles && queuedFiles.length) {
          ctrl.isUploading = true;
          var len = queuedFiles.length;
          while (len--) {
            queuedFiles[len].progress = 0;
            Upload.upload({
              url: ctrl.url,
              data: {
                file: queuedFiles[len],
                idContact: ctrl.idContact,
                idTicket: ctrl.idTicket,
                importType: ctrl.importType
              }
            }).then(
              function (response) {
                $timeout(function () {
                  ctrl.uploadedFiles.push({
                    name: response.data.original,
                    file: response.data.name,
                    fields: response.data.fields ? response.data.fields : [],
                    isActive: true,
                    importSample: response.data.importSample ? response.data.importSample : []
                  });

                  var index = _.findIndex(queuedFiles, function (f) {
                    return f.name === response.data.original;
                  });

                  if (index > -1 && queuedFiles[index]) {
                    queuedFiles[index].progress = 100;
                    queuedFiles[index].uploaded = true;
                  }

                  if (
                    _.every(queuedFiles, function (f) {
                      return f.uploaded;
                    }) ||
                    (queuedFiles.length === 1 && queuedFiles[0].progress === 100)
                  ) {
                    ctrl.isUploading = false;
                    ctrl.onUploadFinished({ files: ctrl.uploadedFiles });
                  }
                });
              },
              function (response) {
                if (response.status > 0) {
                  ctrl.uploadError = response.status + ': ' + response.data;
                }
              },
              function (evt) {
                var index = _.findIndex(queuedFiles, function (f) {
                  return f.name === evt.config.data.file.name;
                });
                queuedFiles[index].progress = parseInt((100.0 * evt.loaded) / evt.total);
                ctrl.uploadProgress =
                  _.reduce(
                    queuedFiles,
                    function (memo, f) {
                      return memo + f.progress;
                    },
                    0
                  ) / (queuedFiles.length === 0 ? 1 : queuedFiles.length);
              }
            );
          }
        } else {
          uiService.toast({
            text: {
              p1: 'File(s)',
              p2: 'are required',
              p3: 'for upload'
            },
            warn: true
          });
        }
      };
      ctrl.removeUpload = function (file) {
        if (ctrl.files instanceof Array) {
          ctrl.files.splice(ctrl.files.indexOf(file), 1);
        } else {
          ctrl.files = null;
        }
      };
      ctrl.getExtension = function (file) {
        return file.name.split('.').pop().toLowerCase();
      };
      ctrl.change = function (
        $files,
        $file,
        $newFiles,
        $duplicateFiles,
        $invalidFiles,
        $event
      ) {
        if (ctrl.autoUpload && $newFiles && $newFiles.length) {
          ctrl.files = $newFiles;
          ctrl.upload();
        }
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.titleText = ctrl.title || 'Drag & drop file(s), or click here to browse';
        ctrl.keepMultiple = ctrl.allowMultiple ? 'distinct' : false;
        ctrl.allowedExtensionsText = ctrl.allowedExtensions
          ? ctrl.allowedExtensions.replace(/\./g, '').replace(/,/g, ', ').toUpperCase()
          : '';
        ctrl.files = ctrl.allowMultiple ? [] : null;
        ctrl.outputDimensions = { w: ctrl.minimumWidth, h: ctrl.minimumHeight };
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.startUpload && changes.startUpload.currentValue === true) {
          ctrl.upload();
        }
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {};
    }
  }
};
